
import api from "./apiService";

const isFileValue = (value) => value instanceof File || value instanceof Blob;

const appendFormDataValue = (formData, key, value) => {
    if (isFileValue(value)) {
        formData.append(key, value);
        return;
    }

    // if (Array.isArray(value)) {
    //     value.forEach((item, index) => {
    //         appendFormDataValue(formData, `${key}[${index}]`, item);
    //     });
    //     return;
    // }
        if (Array.isArray(value)) {
            formData.append(key, JSON.stringify(value));
            return;
        }

    if (value && typeof value === "object") {
        Object.entries(value).forEach(([childKey, childValue]) => {
            appendFormDataValue(formData, `${key}[${childKey}]`, childValue);
        });
        return;
    }

    formData.append(key, value ?? "");
};

const buildFormData = (details) => {
    const formData = new FormData();

    Object.entries(details).forEach(([key, value]) => {
        appendFormDataValue(formData, key, value);
    });

    return formData;
};

const resolveFormData = (details) =>
    details instanceof FormData ? details : buildFormData(details);

export const SurveyService = {
    sendSurveyDetails:async(details)=>{
        return api.post("/survey/save-survey-details", resolveFormData(details), {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    },
    sendSurveyQuestions: async(surveyQusetion)=>{
        return api.post(`/survey/save-survey-questions`, resolveFormData(surveyQusetion), {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    },
    getSurveyPreview: async(surveyId)=>{
        return api.get(`/survey/preview-survey/${surveyId}`)
    },
    getSurveyDetails: async (surveyId) => {
        return api.get(`/survey/survey-details/${surveyId}`);
    },
    getSurveyQuestions: async (surveyId) => {
        return api.get(`/survey/survey-questions/${surveyId}`);
    },
    publishSurvey: async(surveyId)=>{
        return api.post("/survey/publish-survey", {
            survey_id: surveyId,
          })
    },
    fetchSavedSurveys: async()=>{
        return api.get("/survey/fetch-saved-surveys");
    },

    updateSurveyDetails: async (surveyId, data) => {
        return api.put(`/survey/update-survey-details/${surveyId}`, data, {
            headers: {
            "Content-Type": "multipart/form-data",
            },
        });
    },

   updateSurveyQuestions: async (surveyId, formData) => {
    return api.put(
        `/survey/update-survey-questions/${surveyId}`,
        formData,
        {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        }
    );
    },
    deleteSurveyResponse: async (responseId) => {
        return api.delete(`/survey/survey-response/${responseId}`);
    },



};
